export enum DeactivateGuardEnum {
  not_save = "not_save",
  cancel = "cancel",
  save_all = "save_all"
}
